import { useContext } from "react";
import config from "../../config";
import { useQuery } from "@tanstack/react-query";
import { AppContext } from "@/App.context";

const setEditReportData = (token) => {
  return async ({ service, id }) => {
    const setReporting = await fetch(
      `${config.reportApiHost}/v1/${service}/reporting/get/${id}`,
      {
        method: "GET",
        headers: {
          // "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (!setReporting.ok) {
      const errorResponse = await setReporting.json();
      throw new Error(errorResponse.message);
    }
    const data = await setReporting.json();

    return data;
  };
};

export const useGetEditReportData = (req, deps = [], enabled = true) => {
  const appContext = useContext(AppContext);

  const query = useQuery({
    queryKey: ["setEditReportData", req, ...deps],
    queryFn: () => setEditReportData(appContext.idToken)(req),
    enabled,
  });

  return query;
};
